module.exports = __webpack_public_path__ + "static/img/img-1.d2c563d7.png";